import type { SessionExpiredRecovery } from '@core/ports/SessionExpiredRecovery';
import type { NhsAppGateway } from '@core/ports/NhsAppGateway';
import { navigateToTrustedTarget } from '@infrastructure/navigation/trustedNavigation';
import { OriginalOriginStore } from '@infrastructure/storage/OriginalOriginStore';

const fallbackNhsAppTarget = {
  appPage: 'homePage' as const,
  browserUri: 'https://www.nhs.uk/nhs-app/',
};

export class NhsAppSessionExpiredRecovery implements SessionExpiredRecovery {
  public constructor(
    private readonly nhsAppGateway: NhsAppGateway,
    private readonly originalOriginStore: OriginalOriginStore
  ) {}

  public async returnOrFallback(): Promise<void> {
    const originalOrigin = this.originalOriginStore.get();
    const appPage = originalOrigin?.appPage ?? fallbackNhsAppTarget.appPage;
    const browserUri = originalOrigin?.browserUri ?? fallbackNhsAppTarget.browserUri;

    try {
      await this.nhsAppGateway.navigateToAppPage(appPage, browserUri);
      return;
    } catch {
      navigateToTrustedTarget(browserUri, fallbackNhsAppTarget.browserUri);
    }
  }
}